import { render, staticRenderFns } from "./MarkAsDoNotContact.vue?vue&type=template&id=0c606b44"
import script from "./MarkAsDoNotContact.vue?vue&type=script&lang=js"
export * from "./MarkAsDoNotContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports